var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconamoonEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "#1E1E1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Landing Page - Option2",
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 7318,
    transform: "translate(-599 -6900)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop - 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-601 -209C-601 -236.614 -578.614 -259 -551 -259H791C818.614 -259 841 -236.614 841 -209V418H-601V-209Z",
    fill: "url(#paint0_linear_0_1)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 52"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 51"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 36"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iconamoon:email"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.50778 4.44827V3.6123C2.28607 3.6123 2.07344 3.70038 1.91666 3.85715C1.75989 4.01393 1.67181 4.22656 1.67181 4.44827H2.50778ZM17.5551 4.44827H18.3911C18.3911 4.22656 18.303 4.01393 18.1462 3.85715C17.9895 3.70038 17.7768 3.6123 17.5551 3.6123V4.44827ZM2.50778 5.28423H17.5551V3.6123H2.50778V5.28423ZM16.7192 4.44827V14.4798H18.3911V4.44827H16.7192ZM15.8832 15.3158H4.17971V16.9877H15.8832V15.3158ZM3.34374 14.4798V4.44827H1.67181V14.4798H3.34374ZM4.17971 15.3158C3.95799 15.3158 3.74536 15.2277 3.58859 15.071C3.43182 14.9142 3.34374 14.7016 3.34374 14.4798H1.67181C1.67181 15.145 1.93604 15.7829 2.40636 16.2532C2.87668 16.7235 3.51457 16.9877 4.17971 16.9877V15.3158ZM16.7192 14.4798C16.7192 14.7016 16.6311 14.9142 16.4743 15.071C16.3175 15.2277 16.1049 15.3158 15.8832 15.3158V16.9877C16.5483 16.9877 17.1862 16.7235 17.6566 16.2532C18.1269 15.7829 18.3911 15.145 18.3911 14.4798H16.7192Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.50812 4.44824L10.0318 11.9719L17.5555 4.44824",
    stroke: "white",
    strokeWidth: 1.67193,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: -601,
    y1: -259,
    x2: 825.75,
    y2: 419.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED9232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#814403"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 7318,
    fill: "white",
    transform: "translate(-599 -6900)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconamoonEmail);
export default __webpack_public_path__ + "static/media/iconamoon_email.1def332712de810bb9a2eccf7977062f.svg";
export { ForwardRef as ReactComponent };